var _circle, _path, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExt2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76.0945,
    cy: 36.1296,
    r: 12.1296,
    fill: "#C24848"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.7085 43.8718C86.8306 52.9562 80.6183 49.0969 79.5 46L78 42.5C77.1914 41.9609 74.5624 41.2566 73 42.5C72.0691 43.2409 72.1167 44.9957 71.5 47C69.8483 52.368 58.5 49 55.9647 46.9688C53.4293 44.9375 43.8351 32.7746 43.8351 32.7746C43.8351 32.7746 40.2217 27.6129 35.5766 30.968C32.3606 33.2909 35.0605 37.9363 35.0605 37.9363C41.4264 44.2161 53.532 57.5644 60.5 63.5C65.9468 68.1397 64.9113 80.6048 64.2231 86.4545C64.2231 86.4545 51.7581 118.984 51.5 119.5C51.2419 120.016 50.1617 126.845 53.6421 128.005C57.5132 129.295 61.7419 125.032 62 124C62.2581 122.968 74.8043 90.5839 75.3205 88.7774C75.8367 86.9708 79.1916 87.2289 79.7078 88.7774C80.224 90.3258 92.3536 124.392 92.8697 125.424C93.3859 126.457 94.6763 129.812 99.8378 128.779C104.999 127.747 103.967 123.618 103.709 122.327C103.451 121.037 91.8373 86.4545 91.8373 86.4545C89.9448 82.4113 86.5726 72.8797 88.2242 67.0988C89.8759 61.3178 96.9988 53.6788 100.354 50.5818L118.935 34.8392C118.935 34.8392 121.04 29.4925 118.935 27.613C117.056 25.9349 112.483 27.613 112.483 27.613C110.591 29.2475 104.586 34.7875 95.7085 43.8718Z",
    fill: "#C24848"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.3843,
    cy: 35.0972,
    r: 3.355,
    fill: "#E7E7E7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.2886,
    cy: 35.0972,
    r: 3.355,
    fill: "#E7E7E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExt2);
export default __webpack_public_path__ + "static/media/ext-2.9ea71686b2764c5b0a226222d2277518.svg";
export { ForwardRef as ReactComponent };